module.exports = __webpack_public_path__ + "1640f3fc360fa7173f4df4dd070e2260.svg";